import React, { useState } from "react";

//UI Material
import {
  Card,
  Grid,
  Stack,
  Button,
  Avatar,
  CircularProgress,
} from "@mui/material";

//Material icons
import { ArrowBackIos, ArrowForwardIos, Message } from "@mui/icons-material";

//Helpers
import {
  typographyForCustomizedFontSize,
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";
import { selectDateString } from "../../Helpers/date";
import { interactionsSelector } from "../../Helpers/interactionsDictionary";

export default function InteractionsHistory({ interactions = [], loading }) {
  // ==========> Component States <==========
  //State for currente page handle
  const [currentPage, setCurrentPage] = useState(1);
  //Limit of interactions per page
  const interactionsPerPage = 6;

  // ==========> Component Functions <==========
  //Function to generate the transactions in the component
  const generateProductInteractions = () => {
    const orderedInteractions = interactions.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );

    const lastInteraction = currentPage * interactionsPerPage;
    const firstInteraction = lastInteraction - interactionsPerPage;
    const currentInteractions = orderedInteractions.slice(
      firstInteraction,
      lastInteraction
    );

    return currentInteractions.map((interaction) => (
      <Grid item xs={12} key={interaction.interactionNumber}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Avatar>{String(interaction.createdBy[0]).toUpperCase()}</Avatar>
          <Card raised sx={{ padding: "15px", borderRadius: "35px" }}>
            <Stack spacing={0.2} textAlign="left">
              {typographyForCustomizedFontSize(
                interactionsSelector(interaction),
                "13.5px"
              )}
              {typographyForCustomizedFontSize(
                `${selectDateString(
                  interaction.createdAt
                )} por ${interaction.createdBy}`,
                "11px",
                null
              )}
            </Stack>
          </Card>
        </Stack>
      </Grid>
    ));
  };

  const totalPages = Math.ceil(interactions.length / interactionsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const generateInteractionsComponent = () => {
    if (!interactions.length) {
      return (
        <Grid item xs={12}>
          <Stack justifyContent="center" alignItems="center">
            <Message sx={{ fontSize: "70px" }} />
            {typographyForText(
              "No hay interacciones registradas en este producto."
            )}
          </Stack>
        </Grid>
      );
    } else {
      return (
        <Grid container spacing={1}>
          {generateProductInteractions()}
          <Grid item xs={12} sx={{ textAlign: "center" }}>
            <Stack direction="row" justifyContent="center" spacing={1}>
              {currentPage > 1 && (
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<ArrowBackIos />}
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Anterior
                </Button>
              )}
              {currentPage < totalPages && (
                <Button
                  variant="outlined"
                  size="small"
                  endIcon={<ArrowForwardIos />}
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Siguiente
                </Button>
              )}
            </Stack>
          </Grid>
        </Grid>
      );
    }
  };

  // ==========> Component <==========
  return (
    <Card raised sx={{ height: "100%" }}>
      <Grid container spacing={2} sx={{ padding: "15px" }}>
        <Grid item xs={12}>
          {typographyForSubtitles("Historial del producto", "secondary")}
        </Grid>
        <Grid item xs={12}>
          {loading ? <CircularProgress /> : generateInteractionsComponent()}
        </Grid>
      </Grid>
    </Card>
  );
}
